module.exports = __webpack_public_path__ + "static/media/sv.46858d61.svg";